<template>
    <div class="vehicle-summary">
        <h3 class="green-header">Vehicle</h3>
        <dl class="dl-horizontal">
            <dt>Year</dt>
            <dd>{{ year }}</dd>
            <dt>Make</dt>
            <dd>{{ make }}</dd>
            <dt>Model</dt>
            <dd>{{ model }}</dd>
            <dt>VIN</dt>
            <dd>{{ vin }}</dd>
            <dt>License Number</dt>
            <dd>{{ licensePlate }}</dd>
            <dt>License State</dt>
            <dd>{{ licenseState }}</dd>
            <dt>Lienholder</dt>
            <dd>{{ lienholder }}</dd>
            <dt>Insurance Co</dt>
            <dd>{{ insuranceCompany }}</dd>
            <dt>Length</dt>
            <dd>{{ motorhomeLength }}</dd>
            <dt>CMV</dt>
            <dd>{{ cmv }}</dd>
        </dl>
    </div>

</template>

<script>

export default {
  name: 'VehicleSummary',
  props: {
    'year': String,
    'make': String,
    'model': String,
    'vin': String,
    'licensePlate': String,
    'licenseState': String,
    'lienholder': String,
    'insuranceCompany': String,
    'motorhomeLength': String,
    'cmv': String,
  },
}
</script>

<style>
</style>
